import styled, { keyframes } from "styled-components";

// ============================================================================
// Order Skeleton Styles
// ============================================================================
const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

export const ShimmerBlock = styled.div`
  border-radius: 4px;
  background: var(--PEARL, #ecf1f4);
  background-image: linear-gradient(
    90deg,
    var(--PEARL, #ecf1f4) 0%,
    #f2f5f7 20%,
    var(--PEARL, #ecf1f4) 40%,
    var(--PEARL, #ecf1f4) 100%
  );
  background-size: 800px 104px;
  animation: ${shimmer} 1.2s infinite linear;
  height: ${props => props.height || "16px"};
  width: ${props => props.width || "100%"};
  margin: ${props => props.margin || "0"};
`;

// ============================================================================
// Order History Page Styles
// ============================================================================
export const StyledBackLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: none;
  background: #fff;
  padding: 8px 16px;
  cursor: pointer;
  margin-bottom: 24px;
  width: max-content;

  border-radius: 4px;

  color: var(--GREY, #4a4a68);
  text-align: center;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;

  svg {
    width: 16px;
    height: 16px;
    color: #4a4a68;
  }

  &:hover {
    background: #f7f8f9;
  }
`;

export const StyledSectionContainerDiv = styled.div`
  flex: 1;
  font-family: Inter;
  padding: 32px 136px 8px;

  border-top: 1px solid var(--Color-Tokens-Border-Primary, #e4e4e4);
  border-bottom: 1px solid var(--Color-Tokens-Border-Primary, #e4e4e4);
  background: var(--CLOUD, #fcfdfe);

  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  overflow: hidden;
`;

export const TableCard = styled.div`
  border-radius: 4px;
  border: 1px solid #ecf1f4;
  background: #fff;
  overflow: hidden;
  transition: opacity 0.2s ease;
  flex: 1;
  border-bottom: none;
  display: flex;
  flex-direction: column;
  min-height: 0;
  .order-table {
    border-bottom: none;
    min-height: 400px;
  }

  table {
    border-collapse: collapse;
  }

  th {
    border-bottom: 1.6px solid #e9edf5;
    background: #fff;
  }

  td {
    border-bottom: 1px solid #e9edf5;
  }
`;

export const PaginationWrapper = styled.div`
  flex-shrink: 0;
  margin-top: auto;
  padding: 16px 0;
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid #e4e4e4;

  .ant-pagination {
    display: flex;
    align-items: center;
    font-family: Inter, sans-serif;
    font-size: 14px;
    color: #4a4a68;

    .ant-pagination-total-text {
      margin-right: auto;
      font-weight: 500;
      color: #4a4a68;
    }

    .ant-pagination-item {
      font-weight: 600;
      border: none;
      background: transparent;

      a {
        color: #4a4a68;
      }

      &-active {
        background: transparent;
        a {
          color: #2060ea !important;
        }
      }
    }

    .ant-pagination-prev,
    .ant-pagination-next {
      button {
        border: none;
        background: transparent;
      }
    }

    .ant-select-selector {
      border-radius: 6px !important;
      border-color: #d9d9d9 !important;
      font-weight: 500;
      color: #4a4a68;
    }

    .ant-pagination-options-quick-jumper {
      font-weight: 500;
      color: #4a4a68;

      input {
        border-radius: 6px;
        border: 1px solid #d9d9d9;
        font-weight: 600;
        text-align: center;
        width: 50px;
      }
    }
  }
`;

export const FooterWrapper = styled.div`
  flex-shrink: 0;
`;
